import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearJob, editJob, getJob } from '../../actions/jobsAxctions'
import CreateJobView from '../../containers/Jobs/CreateJob/CreateJob'
const EditJob = ({ match,history }) => {
    const dispatch = useDispatch()
    const {job} = useSelector(state=>state.adminJobReducers)
    useEffect(() => {

        dispatch(getJob(match.params.idJob))
        return () => {
            dispatch(clearJob())
        }
    }, [match.params.idJob])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: job?.name || "",
            mimSalary: job?.mimSalary || "",
            maxSalary: job?.maxSalary || "",
            knowledgeArea: job?.knowledgeArea || "",
            description: job?.description || "",
            limitDate: job?.limitDate || "",
            country: job?.country || "",
            state: job?.state || "",
            city: job?.city || "",
            quantityVacancies: job?.quantityVacancies || "",
            company: job?.company || "",
            email: job?.email || "",
            contact: job?.contact || "",

        },
        onSubmit: (values) => {
            const formData = new FormData()
            formData.append("name",values.name)
            formData.append("mimSalary",values.mimSalary)
            formData.append("maxSalary",values.maxSalary)
            formData.append("knowledgeArea",values.knowledgeArea)
            formData.append("description",values.description)
            formData.append("limitDate",values.limitDate)
            formData.append("country",values.country)
            formData.append("state",values.state)
            formData.append("city",values.city)
            formData.append("quantityVacancies",values.quantityVacancies)
            formData.append("company",values.company)
            formData.append("email",values.email)
            formData.append("contact",values.contact)
            formData.append("jobOfferId",job._id)
            if(values.picture){
                formData.append("picture",values.picture)
            }
           
            
            if(values.offerpdf){
                formData.append("offerpdf",values.offerpdf)
            }
       
  
            dispatch(editJob(formData,history))
        }


    })
    return (
        <CreateJobView formik={formik} job={job} isEdit={true} />
    )
}

export default EditJob